import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import b from 'b_';
import Modal from '../Modal';
import { LogoProofpointWord } from '../Logo/PfptLogo';
import './MobileModal.css';

const block = b.lock('MobileModal');

class MobileModal extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
        isOpen: PropTypes.bool.isRequired,
        onClose: PropTypes.func.isRequired,
        children: PropTypes.node.isRequired,
        footerActions: PropTypes.node,
        shouldCloseOnOverlayClick: PropTypes.bool,
    };

    static defaultProps = {
        footerActions: null,
        shouldCloseOnOverlayClick: false,
    };

    render() {
        const {
            isOpen,
            children,
            footerActions,
            shouldCloseOnOverlayClick
        } = this.props;

        return (
            <Modal
                isOpen={isOpen}
                shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
                className="MobileModal"
            >
                <div className="MobileModal__Container">
                    {/* Header with Logo */}
                    <div className={block('Header')}>
                        <div className={block('LogoSection')}>
                            <LogoProofpointWord
                                mainColor="var(--semantic-info-250, #82A5FF)"
                                className={block('Logo')}
                            />
                            <span className={block('IsolationText')}>Isolation</span>
                        </div>
                    </div>

                    {/* Content Area */}
                    <div className="MobileModal__Content">
                        {children}
                    </div>

                    {/* Footer with Actions */}
                    {footerActions && (
                        <div className="MobileModal__Footer">
                            <div className="MobileModal__Actions">
                                {footerActions}
                            </div>
                        </div>
                    )}
                </div>
            </Modal>
        );
    }
}

export default translate()(MobileModal);
